import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ErrorBoundary } from '@/_components';
import Auth from '@/_pages/auth/page';

export const Route = createFileRoute('/auth/')({
  errorComponent: () => <ErrorBoundary fallback={<Navigate to="/" />} />,
  component: Auth,
});
